module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_WFP_ChapHead",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Book Description")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText"
  }, [_vm._v("It is one of the most fundamental questions facing America today: How justifiably, or irresponsibly, do the volatile and unbiased American media—press, television and radio—attempt to interfere with, and control, the political process and the foreign policy of the nation? In a hotly fought Presidential primary, the news media fractures along ideological lines, supporting and distorting the candidates’ records, manipulating the news rather than covering it.  ")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText"
  }, [_c('i', [_vm._v("Capable of Honor")]), _vm._v(", the third novel in the grand, bestselling "), _c('i', [_vm._v("Advise and Consent")]), _vm._v(" saga, is a compelling blockbuster that shines a harsh and revealing spotlight on how the media shapes the news, guides public opinion, creates policy—and tries to shape history itself.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34a0e764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0001.vue
// module id = 60
// module chunks = 0